var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothes4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 226,
    viewBox: "0 0 158 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0031 166.153C9.83251 165.169 6.35718 159.46 7.12006 153.456L21.2756 45.8693C22.208 38.7822 27.972 33.959 33.9902 35.2387C40.0932 36.4198 44.0772 43.1132 42.9752 50.1019L26.0224 157.196C25.09 163.2 20.1737 167.138 15.0031 166.153Z",
    fill: "#FFA39B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.176 173.339L0 167.433L3.3058 144.4L33.5665 150.306L30.176 173.339Z",
    fill: "#B9CBD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03541 162.118C7.03541 162.807 6.52683 163.397 5.93348 163.397C5.34013 163.397 4.83154 162.807 4.83154 162.118C4.83154 161.429 5.34013 160.936 5.93348 160.936C6.52683 160.936 7.03541 161.429 7.03541 162.118Z",
    fill: "#373330"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2793 25.1986C47.5529 27.3641 54.9274 40.1603 52.3845 53.0549L32.5497 155.424L2.88232 149.617L13.1388 45.3772C14.4102 32.1873 25.0057 22.9347 36.2793 25.1986Z",
    fill: "#D3DDE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.978 157.688L115.025 50.594C113.923 43.6053 117.907 36.912 124.01 35.7308C130.029 34.5496 135.792 39.3728 136.725 46.3614L150.88 154.046C151.643 160.05 148.168 165.661 142.997 166.645C137.827 167.728 132.911 163.692 131.978 157.688Z",
    fill: "#FFA39B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.434 150.896L154.694 144.892L158 167.925L127.824 173.929L124.434 150.896Z",
    fill: "#B9CBD7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.169 162.118C153.169 162.807 152.66 163.397 152.067 163.397C151.473 163.397 150.965 162.807 150.965 162.118C150.965 161.429 151.473 160.936 152.067 160.936C152.66 160.936 153.169 161.429 153.169 162.118Z",
    fill: "#373330"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.862 45.8693L155.118 150.109L125.451 155.916L105.616 53.6455C103.073 40.6524 110.448 27.8563 121.721 25.6908C132.995 23.4268 143.591 32.6794 144.862 45.8693Z",
    fill: "#D3DDE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.417 226H27.3784V154.046H128.417V226Z",
    fill: "#373330"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.064 9.25259H92.2228C96.5457 9.25259 129.434 25.7892 129.434 25.8876L128.417 154.046H28.3955L27.5479 25.6907C27.5479 25.6907 58.741 9.25259 63.064 9.25259Z",
    fill: "#E0E8EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.076 61.52H94.2573V53.9407H118.076V61.52Z",
    fill: "#FCFCFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3716 14.9616H83.9166V29.7264H71.3716V14.9616Z",
    fill: "#69224B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3716 29.7265H83.9166V154.932L77.3898 162.118L71.3716 154.932V29.7265Z",
    fill: "#69224B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6437 15.4538L70.5235 31.9904L55.8594 13.4852L57.5547 1.18118L77.6437 15.4538Z",
    fill: "#D3DDE6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8849 0L98.5802 12.4024L84.1703 31.9904L77.3892 15.1585L96.8849 0Z",
    fill: "#D3DDE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes4);
export default __webpack_public_path__ + "static/media/clothes-4.ea2716d9aeba58fa4e19402085e238fd.svg";
export { ForwardRef as ReactComponent };